// ---------------------------------------------------------------------------
// Public (anonymous)
// ---------------------------------------------------------------------------
/**
 * The PUBLIC storage bucket that holds each survey's logo snapshot
 * (`<orgId>/<uuid>.<png|jpg|webp>`) — the only public bucket; only the API
 * writes it (`20261004120000_survey_public_branding.sql`, docs/SURVEYS.md).
 */
export const SURVEY_PUBLIC_BUCKET = "survey-public";
/**
 * The public URL of a survey's logo snapshot — the ONE builder the API (for
 * the respondent's `logo_url`) and the web preview share. `supabaseUrl` is
 * the browser-facing project URL (`SUPABASE_URL` / `VITE_SUPABASE_URL`).
 * Pure string building: no request, no session. NULL without a path.
 */
export function surveyPublicLogoUrl(supabaseUrl, path) {
    if (!path)
        return null;
    const base = supabaseUrl.replace(/\/+$/, "");
    const key = path.split("/").map(encodeURIComponent).join("/");
    return `${base}/storage/v1/object/public/${SURVEY_PUBLIC_BUCKET}/${key}`;
}
/**
 * The shape of a public link token — the ONE rule the API guard uses before
 * any database call: 10 base62 chars (minted since 20261005120000) or the
 * legacy 32 lowercase hex chars (every link shared before keeps working).
 * Mirrors the `surveys_public_token_format` CHECK.
 */
export const SURVEY_PUBLIC_TOKEN_RE = /^(?:[0-9a-f]{32}|[A-Za-z0-9]{10})$/;
// ---------------------------------------------------------------------------
// Coded error envelopes (the web reads `err.envelope?.code`)
// ---------------------------------------------------------------------------
export const SURVEY_ERROR_CODES = {
    /**
     * 409 — the freeze guard refused: `questions` changed after the survey left
     * `draft`, or `status` was set back to `draft`.
     */
    frozen: "survey_frozen",
    /** 409 — a staff response on a survey that is not `open`. */
    notOpen: "survey_not_open",
    /**
     * 404 — the public endpoints, UNIFORMLY for an unknown, draft or flag-off
     * token (no existence oracle), and the public POST for a closed one too
     * (the public GET answers a closed survey with its branding only).
     */
    notFound: "survey_not_found",
    /** 400 — the answers failed `buildSurveyAnswersSchema` for the stored questions. */
    invalidAnswers: "survey_invalid_answers",
    /**
     * 400 — every answerable question was left unanswered (the answers schema's
     * `SURVEY_EMPTY_RESPONSE` issue, or the public RPC's backstop).
     */
    emptyResponse: "survey_empty_response",
};
//# sourceMappingURL=surveysReads.js.map